import TimeoutPage from "./TimeoutPage";
export default TimeoutPage;
